export function truncate(value, length) {
  return value && value.length > length ? value.substring(0, length) + ' [...]' : value
}

export function capitalize(s) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export default {
  truncate,
  capitalize
}
